import { styled, TextField, TextFieldProps } from '@mui/material';
import { forwardRef } from 'react';

export const CustomTextField = styled(
    ({ variant, ...props }: TextFieldProps) => (
        <TextField variant={variant ? variant : 'filled'} {...props} />
    )
)(({ theme, label }) => ({
    '& .MuiInputLabel-root': {
        color: '#999999 !important',
    },
    '& .MuiFilledInput-root': {
        border: `1px solid ${theme.palette.grey[400]}`,
        overflow: 'hidden',
        borderRadius: 4,
        backgroundColor: 'transparent',
        transition: theme.transitions.create([
            'border-color',
            'background-color',
            'box-shadow',
        ]),
        '& .MuiFilledInput-input': {
            padding: label ? '19px 10px 2px 10px' : '10px 10px 11px 10px',
        },
        '&:hover': {
            backgroundColor: theme.custom.inputBackground,
            '&::before': {
                border: 0,
            },
        },
        '&.Mui-disabled': {
            backgroundColor: theme.palette.grey[200],
        },
        '&.Mui-focused': {
            backgroundColor: 'transparent',
            borderColor: theme.palette.grey[900],
        },
        '&.Mui-error': {
            backgroundColor: 'transparent',
            borderColor: theme.palette.error.main,
            '&.Mui-disabled': {
                backgroundColor: theme.palette.grey[200],
            },
        },
        '::before': {
            border: '0 !important',
        },
        '::after': {
            border: 0,
            '&:hover': {
                border: 0,
            },
        },
    },
}));

const TextFieldStyled = forwardRef((props: TextFieldProps, ref) => {
    return (
        <CustomTextField
            {...props}
            // InputLabelProps={{
            //     shrink: props.disabled ? true : undefined,
            // }}
            inputRef={ref}
        />
    );
});

TextFieldStyled.displayName = 'StyledTextField';

export default TextFieldStyled;
